export default __webpack_public_path__ + "static/media/Upload_Schema.643029a7.png";